/** @jsx jsx */
import { Grid, Flex, jsx } from 'theme-ui'
import { useRef } from 'react'
import ArticleCard from '~/components/Article/Card'

const ArticleList = ({
  // search,
  articles,
  forwardSx,
}) => {
  const gridRef = useRef()
  // useEffect(() => {
  //   const articleCards = gridRef.current?.querySelector('> a')
  // }, [search])

  return articles && articles.length > 0 ? (
    <Grid
      ref={gridRef}
      columns={[1, null, 3]}
      gap={['30px', '60px']}
      sx={{ ...forwardSx }}
    >
      {articles.map((article, index) => (
        <ArticleCard key={index} article={article} />
      ))}
    </Grid>
  ) : (
    <Flex
      sx={{
        minHeight: ['200px', '400px'],
        justifyContent: 'center',
        alignItems: 'center',
        color: '#FFDD00',
        fontWeight: 'extraBold',
        fontSize: [4, 6],
      }}
    >
      NO ARTICLES FOUND :(
    </Flex>
  )
}

export default ArticleList
